exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".colwidth[data-v-214a9d45]{min-width:200px!important}a[data-v-214a9d45]:not(.md-button):not(.md-bottom-bar-item):hover{text-decoration:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-214a9d45","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/Overseas/overseasAgentSoa.vue
// module id = 1439
// module chunks = 0